export const PALETTE = {
  ALL: [
    { name: 'Terracotta', hex: '#C4563C', category: 'ALL' },
    { name: 'Lilac', hex: '#A78FBF', category: 'ALL' },
    { name: 'Sand', hex: '#C9A887', category: 'ALL' },
    { name: 'Fuschia', hex: '#D6418A', category: 'ALL' },
    { name: 'Charcoal', hex: '#4A4A4A', category: 'ALL' },
    { name: 'Saffron', hex: '#D4B639', category: 'ALL' },
    { name: 'Orange', hex: '#E07A3D', category: 'ALL' },
    { name: 'Eucalyptus Green', hex: '#7FB69E', category: 'ALL' },
    { name: 'Ocean Blue', hex: '#5B9DBF', category: 'ALL' },
    { name: 'Deep Navy', hex: '#2B4A6F', category: 'ALL' },
    { name: 'Plum', hex: '#7A3C58', category: 'ALL' },
    { name: 'Blush', hex: '#E5A9B8', category: 'ALL' },
    { name: 'Black', hex: '#1A1A1A', category: 'ALL' },
    { name: 'Natural White', hex: '#F5F5F0', category: 'ALL' }
  ],
  LIMITED: [
    { name: 'Terracotta', hex: '#C4563C', category: 'LIMITED' },
    { name: 'Lilac', hex: '#A78FBF', category: 'LIMITED' },
    { name: 'Sand', hex: '#C9A887', category: 'LIMITED' },
    { name: 'Fuschia', hex: '#D6418A', category: 'LIMITED' },
    { name: 'Saffron', hex: '#D4B639', category: 'LIMITED' },
    { name: 'Orange', hex: '#E07A3D', category: 'LIMITED' },
    { name: 'Plum', hex: '#7A3C58', category: 'LIMITED' },
    { name: 'Blush', hex: '#E5A9B8', category: 'LIMITED' }
  ],
  CLASSIC: [
    { name: 'Eucalyptus Green', hex: '#7FB69E', category: 'CLASSIC' },
    { name: 'Pebble Gray', hex: '#9B9B8E', category: 'CLASSIC' },
    { name: 'Ocean Blue', hex: '#5B9DBF', category: 'CLASSIC' },
    { name: 'Charcoal', hex: '#4A4A4A', category: 'CLASSIC' },
    { name: 'Natural White', hex: '#F5F5F0', category: 'CLASSIC' },
    { name: 'Deep Navy', hex: '#2B4A6F', category: 'CLASSIC' },
    { name: 'Black', hex: '#1A1A1A', category: 'CLASSIC' }
  ]
};

export const SIZES = [
  '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12'
];
